export const TYPES = {
  BODY: 'body',
  VIN: 'vin',
};
